import React from 'react';

import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './FaceFields.module.sass';

export function FaceFieldsPoint3(): React.JSX.Element {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={st.FormSection}>
      <div className={st.Field}>
        <Control.Textarea
          errors={errors}
          id="user_data"
          label={t('face-page:edit_face_info.information_label')}
          {...register('user_data', {
            maxLength: validate.maxLength(128),
          })}
        />
      </div>
    </div>
  );
}
